const shared = {
    router: {
        url: process.env.WEB_URL,
        menuUrl: process.env.REPLACE_MENU_PART_WEB,
    },
}

export { shared }
